import React from 'react';
import { useTranslation } from 'react-i18next';

import { FilterIcon } from '../../../../assets';
import { Button } from '../../../Button';
import { Tooltip } from '../../../Tooltip';
import { useTableContext } from '../../contexts';
import { isFilterValueActive } from '../../utils';

import styles from './TableFilterResetButton.module.scss';

export const TableFilterResetButton: React.FC = () => {
    const { t } = useTranslation();
    const {
        resetColumnFilters,
        state: { columnFilters },
    } = useTableContext();

    const activeFiltersCount = columnFilters.filter((filter) => isFilterValueActive(filter.value)).length;
    const hasActiveFilters = activeFiltersCount > 0;

    const actionLabel = hasActiveFilters ? t('table.resetFilters') : t('table.noActiveFilters');

    return (
        <Tooltip content={actionLabel}>
            <span className={styles.trigger}>
                <Button
                    aria-label={
                        hasActiveFilters ? t('table.resetFiltersCount', { count: activeFiltersCount }) : actionLabel
                    }
                    color={hasActiveFilters ? 'primary' : 'light'}
                    disabled={!hasActiveFilters}
                    onClick={() => resetColumnFilters()}
                    prefix={<FilterIcon height={20} width={20} />}
                    variant={hasActiveFilters ? 'secondary' : 'primary'}
                >
                    {activeFiltersCount}
                </Button>
            </span>
        </Tooltip>
    );
};
